export default __webpack_public_path__ + "static/media/perfume.411b7db2.jfif";